import { mockAdminManagementData } from "../data"

export const initialState = {
        statusFilter:  "ALL",
        data:           mockAdminManagementData,
        isLoading:      false,
        error:          "",
    
}